export enum JourneyType {
  Engineer = 'ENG',
  Mobile = 'MOB',
  Sales = '',
}
